module.exports = __webpack_public_path__ + "img/traveller-stopped.c895c4e7.svg";